import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';

const gaxios = require('gaxios');
gaxios.instance.defaults = {
    baseURL: siteConfig.siteUrl.API_URL,
};

const authHeaders = () => ({
    Authorization: localStorage.getItem('access_token'),
    AuthId: localStorage.getItem('id_token'),
});

export function* getReporte({ query }) {
    try {
        const params = query ? '?' + new URLSearchParams(query).toString() : '';
        const res = yield gaxios.request({
            url: `api/bonificaciones-registros/${params}`,
            headers: authHeaders(),
        });
        if (!res.data.success) {
            notification('error', 'Error al cargar el reporte de bonificaciones');
        } else {
            yield put({ type: actions.GET_REPORTE_SUCCESS, payload: res.data.registros });
        }
    } catch (err) {
        notification('error', 'Error al cargar el reporte de bonificaciones');
    }
}

export function* getResumen({ query }) {
    try {
        const params = query ? '?' + new URLSearchParams(query).toString() : '';
        const res = yield gaxios.request({
            url: `api/bonificaciones-registros/resumen${params}`,
            headers: authHeaders(),
        });
        if (!res.data.success) {
            notification('error', 'Error al cargar el resumen de bonificaciones');
        } else {
            yield put({ type: actions.GET_RESUMEN_SUCCESS, payload: res.data.resumen });
        }
    } catch (err) {
        notification('error', 'Error al cargar el resumen de bonificaciones');
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_REPORTE_REQUEST, getReporte),
        takeEvery(actions.GET_RESUMEN_REQUEST, getResumen),
    ]);
}
